export function groupCategories(categories, groups) {
    return (groups || [])
        .map((g) => ({ ...g, items: (categories || []).filter((c) => c.group === g.slug) }))
        .filter((g) => g.items.length > 0);
}
